// Render an internal expression string (operators *, /, -) with friendly math glyphs.
export const prettyExpr = (expr: string): string =>
  (expr || '')
    .replace(/\*/g, ' × ')
    .replace(/\//g, ' ÷ ')
    .replace(/-/g, ' − ')
    .replace(/\s+/g, ' ')
    .trim()
